<template lang="html">
  <div class="">
    <MarketingSubheader />
    <p>Banners</p>
    <BannersComponent />
  </div>
</template>

<script>
import MarketingSubheader from '../../components/MarketingComponents/MarketingSubheader';
import BannersComponent from '../../components/MarketingComponents/BannersComponent';
export default {
  name: "BannersPage",
  components: {
    MarketingSubheader,
    BannersComponent
  }
}
</script>

<style lang="css" scoped>
div p{
  color: rgb(60, 3, 140);
  font-size: 36px;
  font-weight: bold;
}
</style>
